import Provider from './WishListProvider';

export default Provider;
